import { fork } from 'redux-saga/effects';

import { saveSessionTokenWatcher } from '../Session/sagas';
import { cleanFiltersWatcher } from '../Dashboard/sagas';
import { agenciesWatcher } from '../Agencies/sagas';
import { visitsWatcher } from '../Visits/sagas';

function* rootSaga() {
  yield fork(saveSessionTokenWatcher);
  yield fork(cleanFiltersWatcher);
  yield fork(agenciesWatcher);
  yield fork(visitsWatcher);
}

export default rootSaga;
